import React, { FC, memo, MouseEventHandler, CSSProperties } from 'react';
import './index.scss';

export type buttonSize = 'l' | 'm' | 'xl' | 's';
export type buttonType = 'primary' | 'secondary' | 'normal';
export interface Props {
    onClick?: MouseEventHandler<HTMLDivElement>;
    className?: string;
    style?: CSSProperties;
    size?: buttonSize;
    type?: buttonType;
    disabled?: boolean;
}

export const Button: FC<Props> = memo(
    ({
        size = 'm',
        children,
        onClick: handleClick,
        type = 'normal',
        className,
        style,
        disabled
    }) => {
        const sizeClass = `btn-${size}`;
        const typeClass = `btn-${type}`;

        return (
            <div
                className={`ecom-btn hair-line all ${sizeClass} ${typeClass}${
                    disabled ? ' btn-disabled' : ''
                }${className ? ` ${className}` : ''}`}
                style={style ? style : {}}
                onClick={handleClick}
            >
                <div className="ecom-btn__name">{children}</div>
            </div>
        );
    }
);

Button.defaultProps = {
    type: 'normal',
    size: 'm'
};

export default Button;
